import React from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";

type FormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneCountry: string;
  phoneNumber: string;
  country: string;
  companyName: string;
  message: string;
};

type FormErrors = Partial<Record<keyof FormValues, string>>;

type PhoneCountryOption = {
  label: string;
  value: string;
};

type CountryOption = {
  label: string;
  value: string;
};

const phoneCountryOptions: PhoneCountryOption[] = [
  { label: "Afghanistan +93", value: "+93" },
  { label: "Aland Islands +358", value: "+358" },
  { label: "Albania +355", value: "+355" },
  { label: "Algeria +213", value: "+213" },
  { label: "American Samoa +1", value: "+1" },
  { label: "Andorra +376", value: "+376" },
  { label: "Angola +244", value: "+244" },
  { label: "Anguilla +1", value: "+1" },
  { label: "Antarctica +672", value: "+672" },
  { label: "Antigua and Barbuda +1", value: "+1" },
  { label: "Argentina +54", value: "+54" },
  { label: "Armenia +374", value: "+374" },
  { label: "Aruba +297", value: "+297" },
  { label: "Ascension Island +247", value: "+247" },
  { label: "Australia +61", value: "+61" },
  { label: "Austria +43", value: "+43" },
  { label: "Azerbaijan +994", value: "+994" },
  { label: "Bahamas +1", value: "+1" },
  { label: "Bahrain +973", value: "+973" },
  { label: "Bangladesh +880", value: "+880" },
  { label: "Barbados +1", value: "+1" },
  { label: "Belarus +375", value: "+375" },
  { label: "Belgium +32", value: "+32" },
  { label: "Belize +501", value: "+501" },
  { label: "Benin +229", value: "+229" },
  { label: "Bermuda +1", value: "+1" },
  { label: "Bhutan +975", value: "+975" },
  { label: "Bolivia +591", value: "+591" },
  { label: "Bonaire +599", value: "+599" },
  { label: "Bosnia and Herzegovina +387", value: "+387" },
  { label: "Botswana +267", value: "+267" },
  { label: "Brazil +55", value: "+55" },
  { label: "British Indian Ocean Territory +246", value: "+246" },
  { label: "British Virgin Islands +1", value: "+1" },
  { label: "Brunei +673", value: "+673" },
  { label: "Bulgaria +359", value: "+359" },
  { label: "Burkina Faso +226", value: "+226" },
  { label: "Burundi +257", value: "+257" },
  { label: "Cabo Verde +238", value: "+238" },
  { label: "Cambodia +855", value: "+855" },
  { label: "Cameroon +237", value: "+237" },
  { label: "Canada +1", value: "+1" },
  { label: "Caribbean Netherlands +599", value: "+599" },
  { label: "Cayman Islands +1", value: "+1" },
  { label: "Central African Republic +236", value: "+236" },
  { label: "Chad +235", value: "+235" },
  { label: "Chile +56", value: "+56" },
  { label: "China +86", value: "+86" },
  { label: "Christmas Island +61", value: "+61" },
  { label: "Cocos (Keeling) Islands +61", value: "+61" },
  { label: "Colombia +57", value: "+57" },
  { label: "Comoros +269", value: "+269" },
  { label: "Congo (DRC) +243", value: "+243" },
  { label: "Congo (Republic) +242", value: "+242" },
  { label: "Cook Islands +682", value: "+682" },
  { label: "Costa Rica +506", value: "+506" },
  { label: "Cote d'Ivoire +225", value: "+225" },
  { label: "Croatia +385", value: "+385" },
  { label: "Cuba +53", value: "+53" },
  { label: "Curacao +599", value: "+599" },
  { label: "Cyprus +357", value: "+357" },
  { label: "Czechia +420", value: "+420" },
  { label: "Denmark +45", value: "+45" },
  { label: "Djibouti +253", value: "+253" },
  { label: "Dominica +1", value: "+1" },
  { label: "Dominican Republic +1", value: "+1" },
  { label: "Ecuador +593", value: "+593" },
  { label: "Egypt +20", value: "+20" },
  { label: "El Salvador +503", value: "+503" },
  { label: "Equatorial Guinea +240", value: "+240" },
  { label: "Eritrea +291", value: "+291" },
  { label: "Estonia +372", value: "+372" },
  { label: "Eswatini +268", value: "+268" },
  { label: "Ethiopia +251", value: "+251" },
  { label: "Falkland Islands +500", value: "+500" },
  { label: "Faroe Islands +298", value: "+298" },
  { label: "Fiji +679", value: "+679" },
  { label: "Finland +358", value: "+358" },
  { label: "France +33", value: "+33" },
  { label: "French Guiana +594", value: "+594" },
  { label: "French Polynesia +689", value: "+689" },
  { label: "Gabon +241", value: "+241" },
  { label: "Gambia +220", value: "+220" },
  { label: "Georgia +995", value: "+995" },
  { label: "Germany +49", value: "+49" },
  { label: "Ghana +233", value: "+233" },
  { label: "Gibraltar +350", value: "+350" },
  { label: "Greece +30", value: "+30" },
  { label: "Greenland +299", value: "+299" },
  { label: "Grenada +1", value: "+1" },
  { label: "Guadeloupe +590", value: "+590" },
  { label: "Guam +1", value: "+1" },
  { label: "Guatemala +502", value: "+502" },
  { label: "Guernsey +44", value: "+44" },
  { label: "Guinea +224", value: "+224" },
  { label: "Guinea-Bissau +245", value: "+245" },
  { label: "Guyana +592", value: "+592" },
  { label: "Haiti +509", value: "+509" },
  { label: "Honduras +504", value: "+504" },
  { label: "Hong Kong +852", value: "+852" },
  { label: "Hungary +36", value: "+36" },
  { label: "Iceland +354", value: "+354" },
  { label: "India +91", value: "+91" },
  { label: "Indonesia +62", value: "+62" },
  { label: "Iran +98", value: "+98" },
  { label: "Iraq +964", value: "+964" },
  { label: "Ireland +353", value: "+353" },
  { label: "Isle of Man +44", value: "+44" },
  { label: "Israel +972", value: "+972" },
  { label: "Italy +39", value: "+39" },
  { label: "Jamaica +1", value: "+1" },
  { label: "Japan +81", value: "+81" },
  { label: "Jersey +44", value: "+44" },
  { label: "Jordan +962", value: "+962" },
  { label: "Kazakhstan +7", value: "+7" },
  { label: "Kenya +254", value: "+254" },
  { label: "Kiribati +686", value: "+686" },
  { label: "Kosovo +383", value: "+383" },
  { label: "Kuwait +965", value: "+965" },
  { label: "Kyrgyzstan +996", value: "+996" },
  { label: "Laos +856", value: "+856" },
  { label: "Latvia +371", value: "+371" },
  { label: "Lebanon +961", value: "+961" },
  { label: "Lesotho +266", value: "+266" },
  { label: "Liberia +231", value: "+231" },
  { label: "Libya +218", value: "+218" },
  { label: "Liechtenstein +423", value: "+423" },
  { label: "Lithuania +370", value: "+370" },
  { label: "Luxembourg +352", value: "+352" },
  { label: "Macau +853", value: "+853" },
  { label: "Madagascar +261", value: "+261" },
  { label: "Malawi +265", value: "+265" },
  { label: "Malaysia +60", value: "+60" },
  { label: "Maldives +960", value: "+960" },
  { label: "Mali +223", value: "+223" },
  { label: "Malta +356", value: "+356" },
  { label: "Marshall Islands +692", value: "+692" },
  { label: "Martinique +596", value: "+596" },
  { label: "Mauritania +222", value: "+222" },
  { label: "Mauritius +230", value: "+230" },
  { label: "Mayotte +262", value: "+262" },
  { label: "Mexico +52", value: "+52" },
  { label: "Micronesia +691", value: "+691" },
  { label: "Moldova +373", value: "+373" },
  { label: "Monaco +377", value: "+377" },
  { label: "Mongolia +976", value: "+976" },
  { label: "Montenegro +382", value: "+382" },
  { label: "Montserrat +1", value: "+1" },
  { label: "Morocco +212", value: "+212" },
  { label: "Mozambique +258", value: "+258" },
  { label: "Myanmar +95", value: "+95" },
  { label: "Namibia +264", value: "+264" },
  { label: "Nauru +674", value: "+674" },
  { label: "Nepal +977", value: "+977" },
  { label: "Netherlands +31", value: "+31" },
  { label: "New Caledonia +687", value: "+687" },
  { label: "New Zealand +64", value: "+64" },
  { label: "Nicaragua +505", value: "+505" },
  { label: "Niger +227", value: "+227" },
  { label: "Nigeria +234", value: "+234" },
  { label: "Niue +683", value: "+683" },
  { label: "Norfolk Island +672", value: "+672" },
  { label: "North Korea +850", value: "+850" },
  { label: "North Macedonia +389", value: "+389" },
  { label: "Northern Mariana Islands +1", value: "+1" },
  { label: "Norway +47", value: "+47" },
  { label: "Oman +968", value: "+968" },
  { label: "Pakistan +92", value: "+92" },
  { label: "Palau +680", value: "+680" },
  { label: "Palestine +970", value: "+970" },
  { label: "Panama +507", value: "+507" },
  { label: "Papua New Guinea +675", value: "+675" },
  { label: "Paraguay +595", value: "+595" },
  { label: "Peru +51", value: "+51" },
  { label: "Philippines +63", value: "+63" },
  { label: "Pitcairn Islands +64", value: "+64" },
  { label: "Poland +48", value: "+48" },
  { label: "Portugal +351", value: "+351" },
  { label: "Puerto Rico +1", value: "+1" },
  { label: "Qatar +974", value: "+974" },
  { label: "Reunion +262", value: "+262" },
  { label: "Romania +40", value: "+40" },
  { label: "Russia +7", value: "+7" },
  { label: "Rwanda +250", value: "+250" },
  { label: "Saba +599", value: "+599" },
  { label: "Saint Barthelemy +590", value: "+590" },
  { label: "Saint Helena +290", value: "+290" },
  { label: "Saint Kitts and Nevis +1", value: "+1" },
  { label: "Saint Lucia +1", value: "+1" },
  { label: "Saint Martin +590", value: "+590" },
  { label: "Saint Pierre and Miquelon +508", value: "+508" },
  { label: "Saint Vincent and the Grenadines +1", value: "+1" },
  { label: "Samoa +685", value: "+685" },
  { label: "San Marino +378", value: "+378" },
  { label: "Sao Tome and Principe +239", value: "+239" },
  { label: "Saudi Arabia +966", value: "+966" },
  { label: "Senegal +221", value: "+221" },
  { label: "Serbia +381", value: "+381" },
  { label: "Seychelles +248", value: "+248" },
  { label: "Sierra Leone +232", value: "+232" },
  { label: "Singapore +65", value: "+65" },
  { label: "Sint Eustatius +599", value: "+599" },
  { label: "Sint Maarten +1", value: "+1" },
  { label: "Slovakia +421", value: "+421" },
  { label: "Slovenia +386", value: "+386" },
  { label: "Solomon Islands +677", value: "+677" },
  { label: "Somalia +252", value: "+252" },
  { label: "South Africa +27", value: "+27" },
  { label: "South Georgia and the South Sandwich Islands +500", value: "+500" },
  { label: "South Korea +82", value: "+82" },
  { label: "South Sudan +211", value: "+211" },
  { label: "Spain +34", value: "+34" },
  { label: "Sri Lanka +94", value: "+94" },
  { label: "Sudan +249", value: "+249" },
  { label: "Suriname +597", value: "+597" },
  { label: "Sweden +46", value: "+46" },
  { label: "Switzerland +41", value: "+41" },
  { label: "Syria +963", value: "+963" },
  { label: "Taiwan +886", value: "+886" },
  { label: "Tajikistan +992", value: "+992" },
  { label: "Tanzania +255", value: "+255" },
  { label: "Thailand +66", value: "+66" },
  { label: "Timor-Leste +670", value: "+670" },
  { label: "Togo +228", value: "+228" },
  { label: "Tokelau +690", value: "+690" },
  { label: "Tonga +676", value: "+676" },
  { label: "Trinidad and Tobago +1", value: "+1" },
  { label: "Tristan da Cunha +290", value: "+290" },
  { label: "Tunisia +216", value: "+216" },
  { label: "Turkey +90", value: "+90" },
  { label: "Turkmenistan +993", value: "+993" },
  { label: "Turks and Caicos Islands +1", value: "+1" },
  { label: "Tuvalu +688", value: "+688" },
  { label: "Uganda +256", value: "+256" },
  { label: "Ukraine +380", value: "+380" },
  { label: "United Arab Emirates +971", value: "+971" },
  { label: "United Kingdom +44", value: "+44" },
  { label: "United States +1", value: "+1" },
  { label: "Uruguay +598", value: "+598" },
  { label: "US Virgin Islands +1", value: "+1" },
  { label: "Uzbekistan +998", value: "+998" },
  { label: "Vanuatu +678", value: "+678" },
  { label: "Vatican City +379", value: "+379" },
  { label: "Venezuela +58", value: "+58" },
  { label: "Vietnam +84", value: "+84" },
  { label: "Wallis and Futuna +681", value: "+681" },
  { label: "Western Sahara +212", value: "+212" },
  { label: "Yemen +967", value: "+967" },
  { label: "Zambia +260", value: "+260" },
  { label: "Zimbabwe +263", value: "+263" },
];

const countryOptions: CountryOption[] = phoneCountryOptions.map((option) => {
  const country = option.label.replace(/\s+\+\d+$/, "");
  return { label: country, value: country };
});

const initialFormValues: FormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneCountry: "+355",
  phoneNumber: "",
  country: "",
  companyName: "",
  message: "",
};

const SOURCE_VALUE = "website_contact_sales";

export default function ContactSales() {
  const [values, setValues] = React.useState<FormValues>(initialFormValues);
  const [errors, setErrors] = React.useState<FormErrors>({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [submitError, setSubmitError] = React.useState("");

  const handleFieldChange = (
    field: keyof FormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const nextValue = event.target.value;
    setValues((prev) => ({ ...prev, [field]: nextValue }));

    setErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });

    if (submitError) setSubmitError("");
  };

  const validateForm = () => {
    const nextErrors: FormErrors = {};
    if (!values.firstName.trim()) {
      nextErrors.firstName = "First name is required";
    }
    if (!values.lastName.trim()) {
      nextErrors.lastName = "Last name is required";
    }
    if (!values.email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(values.email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }
    return nextErrors;
  };

  const buildPayload = () => {
    const phoneDigits = values.phoneNumber.replace(/\D/g, "").trim();
    const phone = phoneDigits ? `${values.phoneCountry}${phoneDigits}` : "";

    return {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      email: values.email.trim(),
      phone,
      country: values.country.trim(),
      companyName: values.companyName.trim(),
      message: values.message.trim(),
      source: SOURCE_VALUE,
    };
  };

  const resetForm = () => {
    setValues(initialFormValues);
    setErrors({});
    setSubmitError("");
    setIsSubmitting(false);
    setIsSuccess(false);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSubmitting) return;

    const nextErrors = validateForm();
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      setSubmitError("Please fill in the required fields.");
      return;
    }

    setErrors({});
    setSubmitError("");
    setIsSubmitting(true);

    try {
      const payload = buildPayload();
      const response = await api.post("/ResellerLeads", payload);

      if (response.status === 200) {
        setIsSuccess(true);
        setValues(initialFormValues);
        return;
      }

      setSubmitError("Something went wrong. Please try again.");
    } catch {
      setSubmitError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-sales">
      <div className="contact-sales__container">
        <Link to="/" className="contact-sales__back">
          <span className="contact-sales__back-icon">{"<"}</span>
          Back
        </Link>

        <div className="contact-sales__card">
          <h1 className="contact-sales__title">Contact our team</h1>
          <p className="contact-sales__subtitle">
            Fill out the form below, and our team will reach out to discuss how we
            can offer seamless eSIM solutions.
          </p>

          {isSuccess ? (
            <div className="contact-sales__success" role="status" aria-live="polite">
              <span className="contact-sales__success-badge">Submission received</span>
              <h2 className="contact-sales__success-title">
                Thank you for contacting Teltrip.
              </h2>
              <p className="contact-sales__success-text">
                Our team will reach out to you shortly.
              </p>
              <div className="contact-sales__success-actions">
                <Link to="/" className="contact-sales__link">
                  Back to home
                </Link>
                <button
                  type="button"
                  className="contact-sales__link contact-sales__link--button"
                  onClick={resetForm}
                >
                  Submit another request
                </button>
              </div>
            </div>
          ) : (
            <form className="contact-sales__form" onSubmit={handleSubmit} noValidate>
              {submitError && (
                <div className="contact-sales__error-banner" role="alert">
                  {submitError}
                </div>
              )}

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="firstName">
                  First name
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  autoComplete="given-name"
                  className={`contact-sales__input${
                    errors.firstName ? " contact-sales__input--error" : ""
                  }`}
                  placeholder="Type your first name"
                  value={values.firstName}
                  onChange={handleFieldChange("firstName")}
                  aria-invalid={Boolean(errors.firstName)}
                />
                {errors.firstName && (
                  <span className="contact-sales__error">{errors.firstName}</span>
                )}
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="lastName">
                  Last name
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  autoComplete="family-name"
                  className={`contact-sales__input${
                    errors.lastName ? " contact-sales__input--error" : ""
                  }`}
                  placeholder="Type your last name"
                  value={values.lastName}
                  onChange={handleFieldChange("lastName")}
                  aria-invalid={Boolean(errors.lastName)}
                />
                {errors.lastName && (
                  <span className="contact-sales__error">{errors.lastName}</span>
                )}
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  className={`contact-sales__input${
                    errors.email ? " contact-sales__input--error" : ""
                  }`}
                  placeholder="Type your email"
                  value={values.email}
                  onChange={handleFieldChange("email")}
                  aria-invalid={Boolean(errors.email)}
                />
                {errors.email && (
                  <span className="contact-sales__error">{errors.email}</span>
                )}
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="phoneNumber">
                  Phone number (optional)
                </label>
                <div className="contact-sales__phone-row">
                  <select
                    id="phoneCountry"
                    name="phoneCountry"
                    className="contact-sales__select"
                    value={values.phoneCountry}
                    onChange={handleFieldChange("phoneCountry")}
                    aria-label="Country calling code"
                  >
                    {phoneCountryOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <input
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    inputMode="tel"
                    autoComplete="tel"
                    className="contact-sales__input"
                    placeholder="Phone number"
                    value={values.phoneNumber}
                    onChange={handleFieldChange("phoneNumber")}
                  />
                </div>
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="country">
                  Country
                </label>
                <select
                  id="country"
                  name="country"
                  className="contact-sales__select"
                  value={values.country}
                  onChange={handleFieldChange("country")}
                  aria-label="Select your country"
                >
                  <option value="">Select your country</option>
                  {countryOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="companyName">
                  Company name (optional)
                </label>
                <input
                  id="companyName"
                  name="companyName"
                  type="text"
                  autoComplete="organization"
                  className="contact-sales__input"
                  placeholder="Type company name"
                  value={values.companyName}
                  onChange={handleFieldChange("companyName")}
                />
              </div>

              <div className="contact-sales__field">
                <label className="contact-sales__label" htmlFor="message">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="contact-sales__textarea"
                  placeholder="Tell us about your business and how we can assist you. Any details that will help us tailor our services to your needs."
                  rows={5}
                  value={values.message}
                  onChange={handleFieldChange("message")}
                />
              </div>

              <button
                type="submit"
                className={`contact-sales__button${
                  isSubmitting ? " contact-sales__button--loading" : ""
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Continue"}
              </button>

              <p className="contact-sales__note">
                By continuing, you agree to our{" "}
                <a
                  href="https://teltrip.com/policies/terms-of-service"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms &amp; Conditions
                </a>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
